import { defineStore } from 'pinia'
import type { ApplicationType } from '@/stores/type/application.type'
import API from '@/api/apiUrls'
import { useApi } from '@/api/useApi'
import { useBaseStore } from '@haskoning/vue-basestore'

const api = useApi<ApplicationType>()

const baseUrl = API.APPLICATION.BASE

export const useApplicationStore = defineStore('application', () => {
	const baseStore = useBaseStore<ApplicationType>({ service: baseUrl, api })

	const resetState = (): void => {
		baseStore.currentItem.value = null
		baseStore.items.value = []
	}
	return {
		...baseStore,
		resetState
	}
})
